import {
  AboutConfigProtocol,
  ConfigService
} from '../../';

export class AboutConfig implements AboutConfigProtocol {
	public version    = '0.0';
  public brandLogo  = '';

  constructor(private configService: ConfigService) {}

	update(config: any): void {
		if (typeof config.about === 'object') {
      this.brandLogo = typeof config.about.brandLogo === 'string' ? this.configService.getImage(config.about.brandLogo) : this.brandLogo;
			this.version = typeof config.about.version	=== 'string' ? config.about.version	: this.version;
		}
		
		this.configService.about.next(this);
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/config/aboutConfig.ts